import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Giro } from 'src/app/models/giro.model';
import { iUser } from 'src/app/models/user.model';
import { BookService } from 'src/app/services/book.service';

@Component({
  selector: 'app-document-download',
  templateUrl: './document-download.component.html',
  styleUrls: ['./document-download.component.scss']
})
export class DocumentDownloadComponent implements OnInit {
  /**
   * serve avere in input il giro per determinare i file di cui bisogna eseguire il download.
   */
@Input() giro:Array<any>;
@Input() user:iUser;
giroselezionato:Giro = null;
 
public loader = {
    pdf : false,
    zip : false
};
/**
 * serve determinare il titolo in base al giro passato in input.
 */
@Input() title:String;
constructor(
  private bookservice: BookService
) { }

  
  ngOnInit(): void {
  }

  /**
   * Ritorna se i file sono scaricabili confrontanto la data della scadenza del giro cliente
   * con la data di oggi 
   * @returns 
   */
  public downloadAvaible(): Boolean {
    return true;
  } 
  /**
   * Esegue il download degli archivi novità per tipo (PDF|ZIP)
   * @param tipo 
   */
   public async downloadArchivio(tipo:string) { 
    this.isSelected(this.giro);
    this.loader[tipo] = true;
    this.bookservice.scaricaArchivio(tipo, Number(this.giroselezionato.anno), Number(this.giroselezionato.numero), this.user.code).subscribe((data:any) => { 
      let contentType = (tipo === 'pdf') ? 'application/pdf' : 'application/zip';
      const blob = new Blob([data], {type: contentType});
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      let ext = (tipo === 'pdf') ? '.pdf' : '.zip';
      a.download = `giro_${this.giroselezionato.numero}_${this.giroselezionato.anno}${ext}`;
      this.loader[tipo] = false;
      a.click();
      
    });
   /*  this.bookservice.scaricaArchivio(tipo, this.giro.anno, this.giro.numero, this.user.code).subscribe((data) => {
      console.log(data);
    }); */
  }

  /**
   * Ritorna un icona in base all'estenzione passata
   * @param ext 
   * @returns 
   */

  getIcon(ext: string) {
    return '/assets/file-iconset/32px/' + ext + '.png';
  }

  async isSelected(giri) {
    let i = null;
    giri.forEach(giro => {
      i = giri.findIndex(giro => 
        moment(giro.data_fine_prenotazione).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')
      ); 
    if ( giri[i] && giro.descrizione === giri[i].descrizione) {
      this.giroselezionato = giri[i];
    } 
    });
  }
}
